export const routes = [
  {
    name: "Home",
    url: "/",
    active: true,
  },
  {
    name: "Posts",
    url: "/posts",
    active: true,
  },
  {
    name: "Projects",
    url: "/projects",
    active: true,
  },
  {
    name: "Notes",
    active: true,
    url: "/notes",
  },
  {
    name: "About",
    url: "/about",
    active: true,
  },
  {
    name: "FAQ",
    url: "/faq",
    active: true,
  },
  {
    name: "Support",
    url: "/support",
    active: true,
  },
  {
    name: "Settings",
    url: "/settings",
    active: false,
  },
];
